import _isEqual from 'lodash/isEqual';

import {
  getCategoriesPayloadFromLessonForm,
  getLessonCategoryIdsFromApiLesson,
} from 'helpers/getLessonCategoryIdsFromApiLesson';

export const convertDataToForm = (data: any, readOnly: any) => ({
  id: data.id,
  moduleId: data.moduleId,
  courseId: data.courseId,
  status: data.status,
  title: data.title,
  text: data.text,
  type: data.type,
  answers: data.answers,
  answersType: data.answersType,
  free: data.free,
  categories: getLessonCategoryIdsFromApiLesson(data),
  readOnly,
});

export const convertDataToApi = (data: any) => ({
  title: data.title,
  text: data.text,
  answersType: data.answersType,
  answers: data.answers,
  free: data.free,
  categories: getCategoriesPayloadFromLessonForm(data),
});

export const getChangedProperties = ({
  currentLesson,
  nextLesson,
}: {
  currentLesson: any;
  nextLesson: any;
}) => {
  const properties = [];

  if (currentLesson.title !== nextLesson.title) {
    properties.push('title');
  }

  if (currentLesson.text !== nextLesson.text) {
    properties.push('text');
  }

  if (currentLesson.answersType !== nextLesson.answersType) {
    properties.push('answersType');
  }

  if (currentLesson.free !== nextLesson.free) {
    properties.push('free');
  }

  if (!_isEqual(currentLesson.answers, nextLesson.answers)) {
    properties.push('answers');
  }

  if (
    !_isEqual(
      [...getLessonCategoryIdsFromApiLesson(currentLesson)].sort(),
      [...getCategoriesPayloadFromLessonForm(nextLesson)].sort(),
    )
  ) {
    properties.push('categories');
  }

  return properties;
};

export const checkAnswersValid = (lesson: any) =>
  lesson.answers.every(
    (answer: any) => answer.leftContent !== '' && answer.rightContent !== '',
  );
